import { useEffect } from 'react'

const KIOSK_URL = 'https://pos-frontend-kappa-two.vercel.app/?mode=kiosk'

export default function Menu() {
  useEffect(() => {
    // Redirect to kiosk for full menu experience
    window.location.href = KIOSK_URL
  }, [])

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-yellow-500/30 border-t-yellow-500 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-400">Loading menu...</p>
      </div>
    </div>
  )
}
